import { render } from "./ShopForm.vue?vue&type=template&id=9bf2909e&scoped=true"
import script from "./ShopForm.vue?vue&type=script&lang=js"
export * from "./ShopForm.vue?vue&type=script&lang=js"

import "./ShopForm.vue?vue&type=style&index=0&id=9bf2909e&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf2909e"]])

export default __exports__